import {  ErrorObservable  } from './ErrorObservable';

export const _throw = ErrorObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/throw.ts